<!-- <h3>Avancement du projet</h3>
<div class="advanced-project">
  <ul>
    <li>
      <p>Création <span class="start-date d-flex">23/04/2024<pr-project-progress-badge status="VALIDATED"></pr-project-progress-badge></span></p>
    </li>
    <li>
      <p>Instruction  <pr-project-progress-badge status="IN_PROGRESS"></pr-project-progress-badge></p>
    </li>
    <li class="disabled-item">
      <p>Envoi banque  <pr-project-progress-badge status="WAITING"></pr-project-progress-badge></p>
    </li>
    <li class="disabled-item">
      <p>Accord banque <pr-project-progress-badge status="WAITING"></pr-project-progress-badge></p>
    </li>
    <li class="disabled-item">
      <p> Accord client  <pr-project-progress-badge status="WAITING"></pr-project-progress-badge></p>
    </li>
    <li class="disabled-item">
      <p>Edition des offres  <pr-project-progress-badge status="WAITING"></pr-project-progress-badge></p>
    </li>
    <li class="disabled-item">
      <p>Acceptation des offres<pr-project-progress-badge status="WAITING"></pr-project-progress-badge></p>
    </li>
  </ul>
</div> -->
<div [ngClass]="{ 'cards-canceled': annule, cards: !annule }">
  <h3>Avancement du projet</h3>
  @if (loading) {
    <ul class="loader">
      <pr-loader></pr-loader>
    </ul>
  }
  <div class="advanced-project">
    @if (!loading && !annule) {
      <ul>
        @for (stade of projectStades; track stade; let isLast = $last) {
          <li [ngClass]="stade.status == 'WAITING' ? 'disabled-item' : ''">
            <p>
              {{ stade.name }}
              <pr-project-progress-badge
                [status]="stade.status"
              ></pr-project-progress-badge>
            </p>
          </li>
        }
      </ul>
    }

    @if (!loading && annule) {
      <ul>
        <ng-container>
          <li>
            <p>
              Annulé
              <pr-project-progress-badge
                [status]="'CANCELED'"
              ></pr-project-progress-badge>
            </p>
          </li>
        </ng-container>
      </ul>
    }
  </div>
</div>
